import { RootState } from "@/store/store";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { dimensionIdSelector } from "@/store/dimensions/selectors/slice-data/dimensionIdSelector";

export const dimensionSharedCostsRequestSelector = (state: RootState) => {
  const dimensionId = dimensionIdSelector(state);

  if (!dimensionId) {
    return;
  }

  return cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCosts.select(
    { dimensionId },
  )(state);
};
